import { render } from "./AccountSideNav.vue?vue&type=template&id=6fb8d577&scoped=true"
import script from "./AccountSideNav.vue?vue&type=script&lang=js"
export * from "./AccountSideNav.vue?vue&type=script&lang=js"

import "./AccountSideNav.vue?vue&type=style&index=0&id=6fb8d577&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb8d577"]])

export default __exports__